module.exports = __webpack_public_path__ + "media/images/lb/450-9b51fda1a5a7bad989a675c481a48882.svg";